var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xz-bgColor"},[_c('el-row',[_c('Head',{attrs:{"classDetial":_vm.classDetial}}),_c('div',{staticClass:"xz-b m-t-30"},[_c('Context',{attrs:{"cid":_vm.cid,"classDetial":_vm.classDetial}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }